<template>
  <div class="fee">
    <template v-if="overviewFees">
      <div class="fee__asset-info" v-for="(assetFees, asset) in overviewFees" :key="asset">

        <div class="container-header">
          <div class="container-header__title">{{ i18n.fees_your_fees({asset: feesNames[asset]})}}</div>
        </div>

        <!--<div class="fee__header">{{ i18n.fees_your_fees({asset: feesNames[asset]})}}</div>-->
        <div class="container container_40">
          <md-table class="scrollbar">
            <md-table-row>
              <md-table-head>{{i18n.fees_fee_type()}}</md-table-head>
              <md-table-head>{{i18n.fees_subtype()}}</md-table-head>
              <md-table-head>{{i18n.fees_fixed()}}</md-table-head>
              <md-table-head>{{i18n.fees_percent()}}</md-table-head>
              <md-table-head>{{i18n.fees_lower_bound()}}</md-table-head>
              <md-table-head>{{i18n.fees_upper_bound()}}</md-table-head>
            </md-table-row>
            <template v-for="(fee, i) in assetFees">
              <md-table-row :key="i">
                <md-table-cell class="fee-table__type text_large">{{fee.fee_type | localizeFeeType}}</md-table-cell>
                <md-table-cell class="fee-table__subtype text_medium">{{fee.subtype | localizeSubtype}}</md-table-cell>
                <md-table-cell class="fee-table__value text_medium">{{i18n.c(fee.fixed)}} <span class="fee-table__currency">{{ assetIcon (fee.fee_asset) }}</span></md-table-cell>
                <md-table-cell class="fee-table__value text_medium">{{i18n.c(fee.percent)}}%</md-table-cell>
                <md-table-cell class="fee-table__value text_medium">{{i18n.c(fee.lower_bound)}} <span class="fee-table__currency">{{ assetIcon(feesNames[asset]) }}</span></md-table-cell>
                <md-table-cell class="fee-table__value text_medium">{{i18n.c(fee.upper_bound)}} <span class="fee-table__currency">{{ assetIcon(feesNames[asset]) }}</span></md-table-cell>
              </md-table-row>
            </template>
          </md-table>
        </div>
      </div>
    </template>
    <md-card-content v-else>
      {{ i18n.lbl_loading() }}
    </md-card-content>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { feeService } from '@api/fees.service'
  import { filterHiddenAssets } from '@const'
  import { CurrencyHelper } from '@js/helpers/currency.helper'

  export default {
    data: _ => ({
      i18n,
      overviewFees: [],
      feesNames: []
    }),
    async created () {
      try {
        let overviewFees = await feeService.loadAccountFees()
        overviewFees = filterHiddenAssets(overviewFees)
        // Filter non related to project Fee type
        this.overviewFees = Object.values(overviewFees)
                            .map(asset => asset.filter(fee => fee.fee_type !== 5))
        this.getFeesNames()
      } catch (error) {
        console.error(error)
      }
    },
    methods: {
      assetIcon (asset) {
        return CurrencyHelper.getCurrencyIcon(asset)
      },
      getFeesNames () {
        if (this.overviewFees !== null) {
          this.overviewFees.forEach(
            fee => this.feesNames.push(fee[0].asset)
          )
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';

  .fee {
    position: relative;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    z-index: 2;

    & .fee-table__type {
      font-weight: 600;
    }

    & .fee-table__subtype {
      color: $col-text-secondary;
    }
  }

  .fee__asset-info {
    margin-bottom: 2rem;
  }

  .fee__header {
    padding: 1.5rem 1.5rem 0;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/fee/index/Fee.Index.vue